// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\DataCache\PilotsDataCacheUpdateEntities.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Pilot, PilotData, PilotOptions } from 'data/models/Pilot';
import { PilotAgency, PilotAgencyData, PilotAgencyOptions } from 'data/models/PilotAgency';
import { PilotAssignment, PilotAssignmentData, PilotAssignmentOptions } from 'data/models/PilotAssignment';
import { PilotJobOrder, PilotJobOrderData, PilotJobOrderOptions } from 'data/models/PilotJobOrder';
import { PilotJobOrderChange, PilotJobOrderChangeData, PilotJobOrderChangeOptions } from 'data/models/PilotJobOrderChange';
import { PilotJobOrderRelevance, PilotJobOrderRelevanceData, PilotJobOrderRelevanceOptions } from 'data/models/PilotJobOrderRelevance';
import { PilotJobOrderVersion, PilotJobOrderVersionData, PilotJobOrderVersionOptions } from 'data/models/PilotJobOrderVersion';
import { PilotSection, PilotSectionData, PilotSectionOptions } from 'data/models/PilotSection';
import { PilotShiphandlingNote, PilotShiphandlingNoteData, PilotShiphandlingNoteOptions } from 'data/models/PilotShiphandlingNote';

// PilotsDataCacheUpdateEntitiesData is the class that PilotsDataCacheUpdateEntities serializes to/from
export interface PilotsDataCacheUpdateEntitiesData {
	
    PilotAgencies : PilotAgencyData[] | null;
    PilotAssignments : PilotAssignmentData[] | null;
    PilotJobOrderChanges : PilotJobOrderChangeData[] | null;
    PilotJobOrderRelevances : PilotJobOrderRelevanceData[] | null;
    PilotJobOrders : PilotJobOrderData[] | null;
    PilotJobOrderVersions : PilotJobOrderVersionData[] | null;
    Pilots : PilotData[] | null;
    PilotSections : PilotSectionData[] | null;
    PilotShiphandlingNotes : PilotShiphandlingNoteData[] | null;
	
}

// PilotsDataCacheUpdateEntitiesOptions is the class which may be passed to the PilotsDataCacheUpdateEntities constructor to define optional initial data values
export interface PilotsDataCacheUpdateEntitiesOptions {
	
    PilotAgencies? : PilotAgencyOptions[] | null;
    PilotAssignments? : PilotAssignmentOptions[] | null;
    PilotJobOrderChanges? : PilotJobOrderChangeOptions[] | null;
    PilotJobOrderRelevances? : PilotJobOrderRelevanceOptions[] | null;
    PilotJobOrders? : PilotJobOrderOptions[] | null;
    PilotJobOrderVersions? : PilotJobOrderVersionOptions[] | null;
    Pilots? : PilotOptions[] | null;
    PilotSections? : PilotSectionOptions[] | null;
    PilotShiphandlingNotes? : PilotShiphandlingNoteOptions[] | null;
	
}

export class PilotsDataCacheUpdateEntities {
	
    public PilotAgencies : SDataArray<PilotAgency>;
    public PilotAssignments : SDataArray<PilotAssignment>;
    public PilotJobOrderChanges : SDataArray<PilotJobOrderChange>;
    public PilotJobOrderRelevances : SDataArray<PilotJobOrderRelevance>;
    public PilotJobOrders : SDataArray<PilotJobOrder>;
    public PilotJobOrderVersions : SDataArray<PilotJobOrderVersion>;
    public Pilots : SDataArray<Pilot>;
    public PilotSections : SDataArray<PilotSection>;
    public PilotShiphandlingNotes : SDataArray<PilotShiphandlingNote>;
	

    constructor();
    constructor(data : PilotsDataCacheUpdateEntitiesOptions);
    constructor(data: PilotsDataCacheUpdateEntitiesOptions | null = null) {
	    
        this.PilotAgencies = SArray<PilotAgency>([]);
        this.PilotAssignments = SArray<PilotAssignment>([]);
        this.PilotJobOrderChanges = SArray<PilotJobOrderChange>([]);
        this.PilotJobOrderRelevances = SArray<PilotJobOrderRelevance>([]);
        this.PilotJobOrders = SArray<PilotJobOrder>([]);
        this.PilotJobOrderVersions = SArray<PilotJobOrderVersion>([]);
        this.Pilots = SArray<Pilot>([]);
        this.PilotSections = SArray<PilotSection>([]);
        this.PilotShiphandlingNotes = SArray<PilotShiphandlingNote>([]);
	    
    }

    static key(obj : PilotsDataCacheUpdateEntities) {
        return ;
    }
    
    static dataKey(obj : PilotsDataCacheUpdateEntitiesOptions) {
        return ;
    }

    static update(obj : PilotsDataCacheUpdateEntities, data : PilotsDataCacheUpdateEntitiesOptions) {
        S.freeze(() => {
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PilotsDataCacheUpdateEntities.ts